import { render, staticRenderFns } from "./AttachedToPositionsTable.vue?vue&type=template&id=6aa87051&scoped=true"
import script from "./AttachedToPositionsTable.vue?vue&type=script&lang=js"
export * from "./AttachedToPositionsTable.vue?vue&type=script&lang=js"
import style0 from "./AttachedToPositionsTable.vue?vue&type=style&index=0&id=6aa87051&prod&lang=css"
import style1 from "./AttachedToPositionsTable.vue?vue&type=style&index=1&id=6aa87051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa87051",
  null
  
)

export default component.exports